export function InsuranceCard({
  insuranceName,
  policyHolderName,
  memberId,
  aperoUrl,
  availityUrl,
  mcoName,
  planType,
  showExternalLinks = true,
  onResourceClick,
}: {
  insuranceName?: string | null
  policyHolderName?: string | null
  memberId?: string | null
  aperoUrl?: string | null
  availityUrl?: string | null
  mcoName?: string | null
  planType?: string | null
  showExternalLinks?: boolean
  onResourceClick?: (destination: 'apero' | 'availity') => void
}) {
  return (
    <section className="space-y-2 rounded-lg border border-sand bg-white p-4 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-charcoal-50">Insurance</p>
      <p className="text-base font-semibold leading-[1.5] text-charcoal">
        {insuranceName ?? 'Insurance information unavailable'}
      </p>
      {(policyHolderName || memberId) && (
        <p className="text-sm leading-[1.5] text-charcoal-50">
          {policyHolderName && <>Holder: {policyHolderName}</>}
          {policyHolderName && memberId && ' — '}
          {memberId && <>Member ID {memberId}</>}
        </p>
      )}
      {(mcoName || planType) && (
        <p className="text-sm leading-[1.5] text-charcoal-50">
          {mcoName && <>MCO: {mcoName}</>}
          {mcoName && planType && ' — '}
          {planType && <>Plan type: {planType}</>}
        </p>
      )}
      {showExternalLinks && (
        <div className="flex gap-4 pt-1">
          <ExternalLink
            label="Open in Apero"
            href={aperoUrl}
            onClick={() => onResourceClick?.('apero')}
          />
          <ExternalLink
            label="Open in Availity"
            href={availityUrl}
            onClick={() => onResourceClick?.('availity')}
          />
        </div>
      )}
    </section>
  )
}

function ExternalLink({
  label,
  href,
  onClick,
}: {
  label: string
  href?: string | null
  onClick: () => void
}) {
  if (!href) {
    return (
      <span className="text-sm font-medium text-charcoal-50" aria-disabled="true">
        {label} ↗
      </span>
    )
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="text-sm font-semibold text-forest hover:underline"
      onClick={onClick}
    >
      {label} ↗
    </a>
  )
}
